import { images } from '~/themes/variables';
export const generateMobileHeader = (eventImage, eventTitle, cameras, currentCamId, handleCameraSwitch, showMobileTechSupport, eventSubHeading) => {
    const mobileHeader = document.createElement('div');
    mobileHeader.className = 'player-header mobile-header';
    mobileHeader.id = 'fullscreen-mobile-header';
    const firstColumn = document.createElement('div');
    firstColumn.className = 'player-header-column';
    firstColumn.innerHTML = `
    <div class="logo">
      <img src="${eventImage}" alt="event logo" />
    </div>
    <div class="title">
      <span>${eventTitle}</span>
      <span>${eventSubHeading}</span>
    </div>
  `;
    mobileHeader.appendChild(firstColumn);
    if (cameras.length > 0) {
        const middleColumn = document.createElement('div');
        middleColumn.className = 'player-header-column middle-column';
        cameras.forEach((camera) => {
            const selectedCamera = currentCamId === camera.cameraId;
            const cameraButtonDiv = document.createElement('div');
            cameraButtonDiv.className = 'controls-button';
            const cameraButton = document.createElement('button');
            cameraButton.className = selectedCamera
                ? 'mobile-header-button'
                : 'mobile-header-button not-selected';
            cameraButton.id = `mobile-camera-button-${camera.cameraId}`;
            cameraButton.onclick = () => handleCameraSwitch(camera);
            cameraButton.innerHTML = selectedCamera
                ? `
        <span class="icon left">
          <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            data-icon="check"
            class="svg-inline--fa fa-check "
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 448 512">
            <path
              fill="currentColor"
              d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"></path>
          </svg>
        </span>
        ${camera.cameraTitle}
      `
                : `
        <span class="icon left">
          <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            data-icon="video"
            class="svg-inline--fa fa-video "
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 576 512">
            <path
              fill="currentColor"
              d="M0 128C0 92.7 28.7 64 64 64H320c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zM559.1 99.8c10.4 5.6 16.9 16.4 16.9 28.2V384c0 11.8-6.5 22.6-16.9 28.2s-23 5-32.9-1.6l-96-64L416 337.1V320 192 174.9l14.2-9.5 96-64c9.8-6.5 22.4-7.2 32.9-1.6z"></path>
          </svg>
        </span>
        ${camera.cameraTitle}
      `;
            cameraButtonDiv.append(cameraButton);
            middleColumn.append(cameraButtonDiv);
        });
        mobileHeader.append(middleColumn);
    }
    const lastColumn = document.createElement('div');
    lastColumn.className = 'player-header-column last-column';
    const techSupportButton = document.createElement('button');
    techSupportButton.className = 'mobile-header-button';
    techSupportButton.onclick = showMobileTechSupport;
    techSupportButton.innerHTML = `
    <span class="icon left">
      <svg
        aria-hidden="true"
        focusable="false"
        data-prefix="fas"
        data-icon="circle-question"
        class="svg-inline--fa fa-circle-question "
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512">
        <path
          fill="currentColor"
          d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"></path>
      </svg>
    </span>
    Tech Support
  `;
    lastColumn.append(techSupportButton);
    const techSupportContent = document.createElement('div');
    techSupportContent.className = 'tech-support-container';
    techSupportContent.id = 'tech-support-container';
    techSupportContent.innerHTML = `
    <div class="tech-support-inner-container">
      <div class="tech-support-block">
        <div class="tech-support-row">
          <div class="tech-support-message">Can&apos;t hear the service?</div>
          <div class="tech-support-icon-container">
            <img src="${images.noSoundIcon}" alt="No Audio" />
          </div>
        </div>
        <a
          class="tech-support-link"
          href="https://support.oneroomstreaming.com/knowledge/why-cant-i-hear-the-service"
          target="_blank"
          rel="noreferrer">
          <button type="submit" class="tech-support-button">
            View suggestions
          </button>
        </a>
      </div>
      <div class="tech-support-block">
        <div class="tech-support-row">
          <div class="tech-support-message">Error message?</div>
          <div class="tech-support-icon-container">
            <img src="${images.errorIcon}" alt="Error" />
          </div>
        </div>
        <a
          class="tech-support-link"
          href="https://support.oneroomstreaming.com/knowledge/im-getting-an-error-message-what-does-it-mean"
          target="_blank"
          rel="noreferrer">
          <button type="submit" class="tech-support-button">
            View what it means
          </button>
        </a>
      </div>
      <div class="tech-support-footer">
        <p class="tech-support-phrase">For other enquires, please contact us:</p>
        <p class="tech-support-phrase">
          <a href="mailto:support@oneroomstreaming.com">support@oneroomstreaming.com</a>
        </p>
      </div>
    </div>
  `;
    lastColumn.append(techSupportContent);
    mobileHeader.append(lastColumn);
    return mobileHeader;
};
